import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useState, useContext, useEffect } from 'react';
import { FCTheme } from '../../../theming/FCTheme.js';
import { usePopper } from 'react-popper';
import { PopOutMenuStyled } from './style.js';
var PopOutMenu = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var placement = props.placement,
      children = props.children,
      referenceElement = props.referenceElement,
      fitWidthToContent = props.fitWidthToContent,
      _a = props.menuBorderRadius,
      menuBorderRadius = _a === void 0 ? '5px' : _a,
      rest = __rest(props, ["placement", "children", "referenceElement", "fitWidthToContent", "menuBorderRadius"]);

  var _b = useState(null),
      popperElement = _b[0],
      setPopperElement = _b[1];

  var _c = usePopper(referenceElement, popperElement, {
    placement: placement,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }]
  }),
      styles = _c.styles,
      attributes = _c.attributes;

  var theme = useContext(FCTheme);
  useEffect(function () {
    setPopperElement(ref.current);
  }, [popperElement]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopOutMenuStyled, __assign({
    fitWidthToContent: fitWidthToContent,
    theme: theme.theme,
    ref: ref,
    menuBorderRadius: menuBorderRadius,
    style: styles.popper
  }, attributes.popper, rest), children));
});
export default PopOutMenu;